export default __webpack_public_path__ + "static/avatar-kayi-sketch-0-cover-db4a65c6bfc7df71e1af51f43c8f50e4.png";